import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import Login from "../pages/Login";
import Logout from "../pages/Logout";
import Root from "../authLayout/Root";
import AuthLayout from "../authLayout/AuthLayout";
import Authentication from "../authLayout/Authentication";

import Dashboard from "../pages/Dashboard";
import UserList from "../pages/UserMaster/User/UserList";
import UserCreate from "../pages/UserMaster/User/UserCreate";
import RoleList from "../pages/UserMaster/Role/RoleList";
import RoleCreate from "../pages/UserMaster/Role/RoleCreate";
import MasterView from "../pages/Masters/MastersView";
import TypeList from "../pages/UserMaster/Type/TypeList";
import TypeCreate from "../pages/UserMaster/Type/TypeCreate";
import BankList from "../pages/UserMaster/Bank/BankList";
import BankCreate from "../pages/UserMaster/Bank/BankCreate";
import CAUserList from "../pages/UserMaster/CAUser/CAUserList";
import CAUserCreate from "../pages/UserMaster/CAUser/CAUserCreate";
import CompanyList from "../pages/UserMaster/Company/CompanyList";
import CompanyCreate from "../pages/UserMaster/Company/CompanyCreate";
import BankerList from "../pages/UserMaster/Banker/BankerList";
import BankerCreate from "../pages/UserMaster/Banker/BankerCreate";
import ProductList from "../pages/UserMaster/Product/ProductList";
import ProductCreate from "../pages/UserMaster/Product/ProductCreate";
import LeadList from "../pages/Leads/LeadList";
import LeadCreate from "../pages/Leads/LeadCreate";
import IVRExtensionList from "../pages/UserMaster/IVRExtension/IVRExtensionList";
import IVRExtensionCreate from "../pages/UserMaster/IVRExtension/IVRExtensionCreate";
import IVRExtensionUserList from "../pages/UserMaster/IVRExtensionUser/IVRExtensionUserList";
import IVRExtensionUserCreate from "../pages/UserMaster/IVRExtensionUser/IVRExtensionUserCreate";
import OperationLeadList from "../pages/Leads/OperationLeadList";
import BusinessPartnerList from "../pages/UserMaster/BusinessPartner/BusinessPartnerList";
import BusinessPartnerCreate from "../pages/UserMaster/BusinessPartner/BusinessPartnerCreate";
import ViewLeadDocument from "../pages/Leads/ViewLeadDocument";
import LeadFormCreate from "../pages/LeadForm/LeadFormCreate";
import LeadFormOperationTeamCreate from "../pages/LeadForm/LeadFormOperationTeamCreate";
import TelecallerLeadFormCreate from "../pages/LeadForm/TelecallerLeadFormCreate";
import TelecallerLeadList from "../pages/Leads/TelecallerLeadList";
import SuperTelecallerLeadList from "../pages/Leads/SuperTelecallerLeadList";
import SuperTelecallerLeadFormCreate from "../pages/LeadForm/SuperTelecallerLeadFormCreate";
import LeadStatusList from "../pages/UserMaster/LeadStatus/LeadStatusList";
import LeadStatusCreate from "../pages/UserMaster/LeadStatus/LeadStatusCreate";
import BranchCreate from "../pages/UserMaster/Branch/BranchCreate";
import BranchList from "../pages/UserMaster/Branch/BranchList";
import BankAccountList from "../pages/UserMaster/BankAccount/BankAccountList";
import BankAccountCreate from "../pages/UserMaster/BankAccount/BankAccountCreate";
import ProductLevelList from "../pages/UserMaster/ProductLevel/ProductLevelList";
import ProductLevelCreate from "../pages/UserMaster/ProductLevel/ProductLevelCreate";
import ProcessFeeList from "../pages/UserMaster/ProcessFee/ProcessFeeList";
import ProcessFeeCreate from "../pages/UserMaster/ProcessFee/ProcessFeeCreate";
import AccountantLeadList from "../pages/Leads/AccountantLeadList";
import AccountantProcessFeeList from "../pages/UserMaster/ProcessFee/AccountantProcessFeeList";
import AdminProcessFeeList from "../pages/UserMaster/ProcessFee/AdminProcessFeeList";
import StateCitiesList from "../pages/UserMaster/StateCities/StateCitiesList";
import StateCitiesCreate from "../pages/UserMaster/StateCities/StateCitiesCreate";
import StateBulkCitiesCreate from "../pages/UserMaster/StateCities/StateBulkCitiesCreate";
import LoanFileList from "../pages/LoanFile/LoanFileList";
import LoanFileCreate from "../pages/LoanFile/LoanFileCreate";
import AdminLoanFileList from "../pages/LoanFile/AdminLoanFileList";
import UserLeadInfoList from "../pages/Leads/UserLeadInfoList";
import RevenueSummaryReport from "../pages/Reports/RevenueSummaryReport";
import RevenueSummaryReport2 from "../pages/Reports/RevenueSummaryReport2";
import TelecallerWisePerformaceLoanReport from "../pages/Reports/TelecallerWisePerformaceLoanReport";
import OperationDepartmentReport from "../pages/Reports/OperationDepartmentReport";
import BusinessPartnerReport from "../pages/Reports/BusinessPartnerReport";
import StateWiseReport from "../pages/Reports/StateWiseReport";
import ProjectReportAndCMAReport from "../pages/Reports/ProjectReportAndCMAReport";
import RetailPipeline from "../pages/Leads/RetailPipeline";
import WholesalePipeline from "../pages/Leads/WholesalePipeline";
import LeadFormOperationTeamAdminCreate from "../pages/LeadForm/LeadFormOperationTeamAdminCreate";
import LeadFormTeleCallerTeamAdminCreate from "../pages/LeadForm/LeadFormTeleCallerTeamAdminCreate";
import DataLimit from "../pages/UserMaster/DataLimit/DataLimit";
import CourseReport from "../pages/Reports/CourseReport";
import SoftwareReport from "../pages/Reports/SoftwareReport";
import SubsidyReport from "../pages/Reports/SubsidyReport";
import Nivesh4uReport from "../pages/Reports/Nivesh4uReport";
import CFOMSMEReport from "../pages/Reports/CFOMSMEReport";
import DeleteLeadList from "../pages/Leads/DeleteLeadList";
import UserLeadInfoDeleteDataList from "../pages/Leads/UserLeadInfoDeleteDataList";


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Root />}>
      <Route element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
      </Route>
      <Route path="/" element={<Authentication />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="masters" element={<MasterView />} />
        <Route path="user-master/type/list" element={<TypeList />} />
        <Route path="user-master/type/create" element={<TypeCreate />} />
        <Route path="user-master/type/edit" element={<TypeCreate />} />

        <Route path="user-master/role/list" element={<RoleList />} />
        <Route path="user-master/role/create" element={<RoleCreate />} />
        <Route path="user-master/role/edit" element={<RoleCreate />} />

        <Route path="user-master/bank/list" element={<BankList />} />
        <Route path="user-master/bank/create" element={<BankCreate />} />
        <Route path="user-master/bank/edit" element={<BankCreate />} />

        <Route path="user-master/banker/list" element={<BankerList />} />
        <Route path="user-master/banker/create" element={<BankerCreate />} />
        <Route path="user-master/banker/edit" element={<BankerCreate />} />

        <Route path="user-master/CAUser/list" element={<CAUserList />} />
        <Route path="user-master/CAUser/create" element={<CAUserCreate />} />
        <Route path="user-master/CAUser/edit" element={<CAUserCreate />} />

        <Route path="user-master/company/list" element={<CompanyList />} />
        <Route path="user-master/company/create" element={<CompanyCreate />} />
        <Route path="user-master/company/edit" element={<CompanyCreate />} />

        <Route path="user-master/user/list" element={<UserList />} />
        <Route path="user-master/user/create" element={<UserCreate />} />
        <Route path="user-master/user/edit" element={<UserCreate />} />

        <Route path="user-master/product/list" element={<ProductList />} />
        <Route path="user-master/product/create" element={<ProductCreate />} />
        <Route path="user-master/product/edit" element={<ProductCreate />} />

        <Route path="user-master/product-level/list" element={<ProductLevelList />} />
        <Route path="user-master/product-level/create" element={<ProductLevelCreate />} />
        <Route path="user-master/product-level/edit" element={<ProductLevelCreate />} />

        <Route path="accountant-process-fee/list" element={<AccountantProcessFeeList />} />
        <Route path="admin-process-fee/list" element={<AdminProcessFeeList />} />
        <Route path="process-fee/list" element={<ProcessFeeList />} />
        <Route path="process-fee/create" element={<ProcessFeeCreate />} />
        <Route path="process-fee/edit" element={<ProcessFeeCreate />} />

        <Route path="lead/list" element={<LeadList />} />
        <Route path="lead/create" element={<LeadCreate />} />
        <Route path="lead/edit" element={<LeadCreate />} />

        <Route path="user-master/business-partner/list" element={<BusinessPartnerList />} />
        <Route path="user-master/business-partner/create" element={<BusinessPartnerCreate />} />
        <Route path="user-master/business-partner/edit" element={<BusinessPartnerCreate />} />

        <Route path="user-master/IVRExtension/list" element={<IVRExtensionList />} />
        <Route path="user-master/IVRExtension/create" element={<IVRExtensionCreate />} />
        <Route path="user-master/IVRExtension/edit" element={<IVRExtensionCreate />} />

        <Route path="user-master/IVRExtensionUser/list" element={<IVRExtensionUserList />} />
        <Route path="user-master/IVRExtensionUser/create" element={<IVRExtensionUserCreate />} />
        <Route path="user-master/IVRExtensionUser/edit" element={<IVRExtensionUserCreate />} />

        <Route path="user-master/lead-status/list" element={<LeadStatusList />} />
        <Route path="user-master/lead-status/create" element={<LeadStatusCreate />} />
        <Route path="user-master/lead-status/edit" element={<LeadStatusCreate />} />

        <Route path="user-master/Branch/list" element={<BranchList />} />
        <Route path="user-master/Branch/create" element={<BranchCreate />} />
        <Route path="user-master/Branch/edit" element={<BranchCreate />} />
        
        <Route path="operation-lead/list" element={<OperationLeadList />} />
        <Route path="view-lead-document" element={<ViewLeadDocument />} />
        <Route path="lead-form-create" element={<LeadFormCreate />} />

        <Route path="user-master/bank-account/list" element={<BankAccountList />} />
        <Route path="user-master/bank-account/create" element={<BankAccountCreate />} />
        <Route path="user-master/bank-account/edit" element={<BankAccountCreate />} />

        <Route path="telecaller-lead/list" element={<TelecallerLeadList />} />
        <Route path="telecaller-lead-form-create" element={<TelecallerLeadFormCreate />} />

        <Route path="super-telecaller-lead/list" element={<SuperTelecallerLeadList />} />
        <Route path="super-telecaller-lead-form-create" element={<SuperTelecallerLeadFormCreate />} />

        <Route path="lead-form-operation-team-create" element={<LeadFormOperationTeamCreate />} />
        <Route path="accountant-lead-list" element={<AccountantLeadList />} />

        <Route path="user-master/stateCities/list" element={<StateCitiesList />} />
        <Route path="user-master/stateCities/create" element={<StateCitiesCreate />} />
        <Route path="user-master/stateCitiesBulk/create" element={<StateBulkCitiesCreate />} />
        <Route path="user-master/stateCities/edit" element={<StateCitiesCreate />} />

        <Route path="admin-loan-file" element={<AdminLoanFileList />} />
        <Route path="view-loan-file" element={<LoanFileList />} />
        <Route path="create-loan-file" element={<LoanFileCreate />} />
        
        <Route path="user-lead-info" element={<UserLeadInfoList />} />
        <Route path="user-lead-info-delete-data" element={<UserLeadInfoDeleteDataList />} />
        {/* Reports */}
        <Route path="revenue-summary" element={<RevenueSummaryReport />} />
        <Route path="revenue-summary2" element={<RevenueSummaryReport2 />} />
        <Route path="business_partner_report" element={<BusinessPartnerReport />} />
        <Route path="state_wise_report" element={<StateWiseReport />} />
        <Route path="project_report_and_cma_report" element={<ProjectReportAndCMAReport />} />
        <Route path="course_report" element={<CourseReport />} />
        <Route path="software" element={<SoftwareReport />} />
        <Route path="subsidy" element={<SubsidyReport />} />
        <Route path="nivesh4u" element={<Nivesh4uReport />} />
        <Route path="cfomsme" element={<CFOMSMEReport />} />

        <Route path="retail-pipeline" element={<RetailPipeline />} />
        <Route path="wholesale-pipeline" element={<WholesalePipeline />} />
        <Route path="operation-department" element={<OperationDepartmentReport />} />
        <Route path="lead-form-operation-team-admin-create" element={<LeadFormOperationTeamAdminCreate />} />
        <Route path="lead-form-telecaller-team-admin-create" element={<LeadFormTeleCallerTeamAdminCreate />} />
        <Route path="telecaller-department" element={<TelecallerWisePerformaceLoanReport />} />
        <Route path="data-limit" element={<DataLimit />} />
        <Route path="delete-lead-list" element={<DeleteLeadList />} />
      </Route>
      <Route path="logout" element={<Logout />} />
    </Route>
  )
);

export default router;